import {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { listarInventarioVentaUseCase } from "../../../core/inventarios/application/listarInventarioxVenta.usecase.js";

/**
 * InventarioVentaContext
 * -----------------
 * Contexto de solo lectura para el inventario.
 * Permite:
 * - Acceder al inventario cargado
 * - Saber si está cargando
 * - Recargar inventario con filtros dinámicos
 */
const InventarioVentaContext = createContext(null);

// Hook seguro para consumir el contexto
export const useInventarioVenta = () => {
  const context = useContext(InventarioVentaContext);
  if (!context) {
    throw new Error("useInventario debe usarse dentro de InventarioVentaProvider");
  }
  return context;
};

export function InventarioVentaProvider({ children }) {
  const [inventario, setInventario] = useState([]);
  const [loading, setLoading] = useState(false);

  const listarInventarioMetodo = useCallback(async (filtros = {}) => {
    setLoading(true);
    try {
      const data = await listarInventarioVentaUseCase(filtros);
      setInventario(data); 
      console.log("Inventario Ventas cargado:", data);
    } catch (error) {
      console.error("Error cargando inventario:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  /**
   * Carga inicial del inventario
   */
  useEffect(() => {
    listarInventarioMetodo();
  }, [listarInventarioMetodo]);

  return (
    <InventarioVentaContext.Provider
      value={{
        inventario,
        loading,
        listarInventarioMetodo,
      }}
    >
      {children}
    </InventarioVentaContext.Provider>
  );
}
